<div class="d-flex align-items-center"
    [style.padding-top.px]="item?.padding"
    [style.padding-bottom.px]="item?.padding"    
>
    <div class="col-12">
        <hr />
    </div>
</div>